"use client";

import { useUserbackFeedback } from "@/hooks/use-userback-feedback";
import { Lightbulb } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";

export function SuggestFeatureCard({ className }: PromotionalCardProps) {
	const { openFeedback } = useUserbackFeedback();

	return (
		<PromotionalCardBase
			icon={<Lightbulb className="w-full h-full" strokeWidth={1.5} />}
			title="Have an Idea?"
			description="Help us build a better home-buying experience — your feedback shapes our roadmap"
			ctaText="Suggest a Feature"
			onClick={openFeedback}
			className={className}
			iconColor="text-amber-500"
		/>
	);
}
